const initialState = {
  divisionsOfUsersOfReservations: {},
  divisionVisibilities: {}
};

export default initialState;
